(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('organisationSquares', organisationSquares);

    function organisationSquares() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/organisation-squares/organisation-squares.html',
            controller: 'OrganisationSquaresController',
            controllerAs: 'vd',
            bindToController: {
                selectedPosition: '=?',
                organisation: '=',
                profile: '='
            },
           
        };
        return directive;
    }
})();
